import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'));
export default SvgIcon;
export const EFTime = dynamic(() => import('./Icon/EFTime'));
export const EFTimeH5 = dynamic(() => import('./Icon/EFTimeH5'));
export const EFFuel = dynamic(() => import('./Icon/EFFuel'));
export const EFFuelH5 = dynamic(() => import('./Icon/EFFuelH5'));
export const EFEnv = dynamic(() => import('./Icon/EFEnv'));
export const EFEnvH5 = dynamic(() => import('./Icon/EFEnvH5'));
export const EFNoise = dynamic(() => import('./Icon/EFNoise'));
export const EFNoiseH5 = dynamic(() => import('./Icon/EFNoiseH5'));
export const EFPlayBtn = dynamic(() => import('./Icon/EFPlayBtn'));
export const EFCOAlert = dynamic(() => import('./Icon/EFCOAlert'));
export const EFCOAlertH5 = dynamic(() => import('./Icon/EFCOAlertH5'));
export const EFFuelAlert = dynamic(() => import('./Icon/EFFuelAlert'));
export const EFFuelAlertH5 = dynamic(() => import('./Icon/EFFuelAlertH5'));
export const EFEngineOilAlert = dynamic(() => import('./Icon/EFEngineOilAlert'));
export const EFEngineOilAlertH5 = dynamic(() => import('./Icon/EFEngineOilAlertH5'));
export const EFTemperatureProtection = dynamic(() => import('./Icon/EFTemperatureProtection'));
export const EFTemperatureProtectionH5 = dynamic(() => import('./Icon/EFTemperatureProtectionH5'));
export const EFOverload = dynamic(() => import('./Icon/EFOverload'));
export const EFOverloadH5 = dynamic(() => import('./Icon/EFOverloadH5'));
export const EFReplayH5 = dynamic(() => import('./Icon/EFReplayH5'));
